import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'

export const getDashboardReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/dashboard', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.page,
    params: data
  })
}

// export const getDashboardReportService = (data) => {
//   return axiosInstance(METHOD_TYPES.get, '/report/dashboard-game-reports', {}, {
//     server: microServices.USER_URL,
//     loader: LOADER_HANDLER_TYPES.page,
//     params: data
//   })
// }

export const getPlinkoGameDailyStatisticsService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/plinko-game-daily-statistics', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.page,
    params: data
  })
}

export const getLimboGameDailyStatisticsService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/limbo-game-daily-statistics', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.page,
    params: data
  })
}

export const getMineGameDailyStatisticsService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/mine-game-daily-statistics', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.page,
    params: data
  })
}

export const getCoinHeistGameDailyStatisticsService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/coin-heist-game-daily-statistics', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.page,
    params: data
  })
}

export const getDiceGameDailyStatisticsService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/dice-game-daily-statistics', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.page,
    params: data
  })
}

export const getHiloGameDailyStatisticsService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/hilo-game-daily-statistics', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.page,
    params: data
  })
}

export const getCoinFlipGameDailyStatisticsService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/coin-flip-game-daily-statistics', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.page,
    params: data
  })
}

export const getKenoGameDailyStatisticsService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/keno-game-daily-statistics', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.page,
    params: data
  })
}

export const getRouletteGameDailyStatisticsService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/roulette-game-daily-statistics', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.page,
    params: data
  })
}
